import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="agent-table"
export default class extends Controller {
  static targets = [
    'column', 'columnToggle', 'caretOpen', 'caretClose'
  ]

  connect() {
    this.open = false

    this.columnToggleTarget.addEventListener('click', (e)=>{
      this.open = !this.open

      if (this.open) {
        this.columnTargets.forEach((e)=>{
          e.classList.remove('hidden')
        })
        this.caretOpenTarget.classList.add('hidden')
        this.caretCloseTarget.classList.remove('hidden')

        this.element.classList.remove('overflow-x-auto')
        this.element.classList.add('overflow-visible')
      } else {
        this.columnTargets.forEach((e)=>{
          e.classList.add('hidden')
        })
        this.caretCloseTarget.classList.add('hidden')
        this.caretOpenTarget.classList.remove('hidden')

        this.element.classList.remove('overflow-visible')
        this.element.classList.add('overflow-x-auto')
      }
    })
  }
}
